import { render, staticRenderFns } from "./AdministrationMethodsDictionary.vue?vue&type=template&id=6abf7fbc&lang=pug&"
import script from "./AdministrationMethodsDictionary.vue?vue&type=script&lang=js&"
export * from "./AdministrationMethodsDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports